import { render, staticRenderFns } from "./messagetip.vue?vue&type=template&id=7f4c481e&scoped=true&"
import script from "./messagetip.vue?vue&type=script&lang=js&"
export * from "./messagetip.vue?vue&type=script&lang=js&"
import style0 from "./messagetip.vue?vue&type=style&index=0&id=7f4c481e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4c481e",
  null
  
)

export default component.exports